<form class="fix-editor">
    <mat-form-field class="ag-row fix-mat-form">
        <input
            matInput
            [type]="inputType()"
            [formControl]="maskedDateFormControl()"
            dateMask
            [maskOptions]="maskConfigOptions()"
            [focusSelectOn]="cellReady()"
            [ready]="cellReady()"
        />
    </mat-form-field>
</form>
